import { BasketItem } from "@hermes/api-model-basket";

export const isBasketItemEngraving = (item: BasketItem): boolean =>
    Boolean(item.customOptions?.engraving?.length);
